const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/role/index.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/user-management/role/index.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RoleDirectoryPendingState } from '@/features/user-management/components/RoleDirectoryPendingState';
import { userManagementPermissionSetsQuery } from '@/features/user-management/services/userManagementQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/user-management/role/')({
  loader: ({
    context
  }) => context.queryClient.ensureQueryData(userManagementPermissionSetsQuery),
  pendingComponent: RoleDirectoryPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});